/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Detailed summary for an account
 */
export interface CloudCostMgmtDetailedSummary { 
    /**
     * Total monthly cost in USD
     */
    total_cost: number;
    /**
     * Potential monthly savings in USD
     */
    potential_savings: number;
    /**
     * Total savings realized from cleaned resources in USD
     */
    realized_savings: number;
    /**
     * Total number of resources
     */
    total_resources: number;
    /**
     * Number of unused resources
     */
    unused_resources: number;
    /**
     * Number of cleaned resources
     */
    cleaned_candidates: number;
}

